import { CountryCode } from '../enums/country-code.enum';
import { Language } from '../models/language.model';

export const REGIONALIZATION_DEFAULT_COUNTRY_CODE =
  CountryCode.UnitedStatesOfAmerica;
export const REGIONALIZATION_DEFAULT_LANGUAGE_CODE = 'en';

export const REGIONALIZATION_DEFAULT_LANGUAGE: Language = {
  code: REGIONALIZATION_DEFAULT_LANGUAGE_CODE,
  name: 'English',
  displayName: 'English',
};

export const REGIONALIZATION_SUPPORTED_LANGUAGES: Language[] = [
  REGIONALIZATION_DEFAULT_LANGUAGE,
  {
    code: 'es',
    name: 'Spanish',
    displayName: 'Español',
  },
  {
    code: 'fr',
    name: 'French',
    displayName: 'Français',
  },
  {
    code: 'de',
    name: 'German',
    displayName: 'Deutsch',
  },
  {
    code: 'id',
    name: 'Indonesian',
    displayName: 'Bahasa Indonesia',
  },
  {
    code: 'zh-TW',
    name: 'Chinese Traditional',
    displayName: '中文（繁體）',
  },
  {
    code: 'it',
    name: 'Italian',
    displayName: 'Italiano',
  },
  {
    code: 'ja',
    name: 'Japanese',
    displayName: '日本語',
  },
  {
    code: 'ko',
    name: 'Korean',
    displayName: '한국어',
  },
  {
    code: 'pl',
    name: 'Polish',
    displayName: 'Polski',
  },
  {
    code: 'pt',
    name: 'Portuguese',
    displayName: 'Português',
  },
  {
    code: 'ro',
    name: 'Romanian',
    displayName: 'Română',
  },
  {
    code: 'th',
    name: 'Thai',
    displayName: 'ไทย',
  },
];
